var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadCancelPlayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05938 4.00011L7.35937 1.70011C7.64937 1.41011 7.64937 0.930107 7.35937 0.640107C7.06937 0.350107 6.58938 0.350107 6.29938 0.640107L3.99937 2.94011L1.69937 0.640107C1.40937 0.350107 0.929375 0.350107 0.639375 0.640107C0.349375 0.930107 0.349375 1.41011 0.639375 1.70011L2.93937 4.00011L0.639375 6.30011C0.349375 6.59011 0.349375 7.07011 0.639375 7.36011C0.789375 7.51011 0.979375 7.58011 1.16937 7.58011C1.35937 7.58011 1.54937 7.51011 1.69937 7.36011L3.99937 5.06011L6.29938 7.36011C6.44938 7.51011 6.63937 7.58011 6.82937 7.58011C7.01937 7.58011 7.20937 7.51011 7.35937 7.36011C7.64937 7.07011 7.64937 6.59011 7.35937 6.30011L5.05938 4.00011Z",
    fill: "#0F1653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCancelPlayer);
export default __webpack_public_path__ + "static/media/download-cancel-player.f8d9e8827a48fa8f7ef7f7a586fdb7e4.svg";
export { ForwardRef as ReactComponent };